module.exports = __webpack_public_path__ + "static/media/graph.f921721b.jpg";